import React from "react";
import Navbar from "../resuables/navbar";
import Footer from "../resuables/footer";
import QuickContact from "../resuables/quick-contact";
import { useEffect } from "react";
import EventPic from "../resources/images/WhatsApp Image 2025-05-23 at 12.58.50_cc1d3d9d.jpg";

function Events() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="main">
      {/* <QuickContact/> */}
      <Navbar />
      <div className="content">
        <div className="content-header-container">
          <div className="bg-pattern"></div>

          <h2 className="content-name">Our News & Events</h2>
        </div>
        <br />
        <div className="content-page-img">
          <img src={EventPic} alt="" />
        </div>
        <p className="construction-note">Still Under Construction</p>
      </div>
      <Footer />
    </div>
  );
}

export default Events;
